import { render, staticRenderFns } from "./Gifts.vue?vue&type=template&id=73f44d56&scoped=true&"
import script from "./Gifts.vue?vue&type=script&lang=js&"
export * from "./Gifts.vue?vue&type=script&lang=js&"
import style0 from "./Gifts.vue?vue&type=style&index=0&id=73f44d56&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f44d56",
  null
  
)

export default component.exports